/**
 * Write into a text field as the trainer's own editing would: the browser's editing command keeps
 * it one step on the undo stack (Ctrl Z, R58). Where the command is not there, the value is set and
 * the input announced, so a controlled field's state follows either way.
 *
 * Call it from an event handler or a callback, never from a React effect: an input event raised
 * during an effect's flush is answered by React restoring the field's previous value, which breaks
 * both the write and the undo step.
 */
export function writeInto(node: HTMLTextAreaElement, start: number, end: number, insert: string): void {
  node.focus();
  node.setSelectionRange(start, end);
  // `execCommand` is the only way an inserted text joins the field's own undo stack.
  const edited = typeof document.execCommand === 'function' && document.execCommand(insert === '' ? 'delete' : 'insertText', false, insert);
  if (edited) return;
  node.setRangeText(insert, start, end, 'end');
  node.dispatchEvent(new Event('input', { bubbles: true }));
}
